import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';
import Hero from './components/Hero';
import CategoriesSection from './components/CategoriesSection';
import FeatureCards from './components/FeatureCards';
import IntroSection from './components/IntroSection';
import ArticlePreview from './components/ArticlePreview';

const SITE_URL = 'https://sugargoosheet.bar';
const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Sugargoo Sheet',
  url: SITE_URL,
  logo: FAVICON_URL,
  description: 'The ultimate Sugargoo Spreadsheet resource platform with curated product finds, shopping guides, and expert reviews.',
  sameAs: ['https://kaspreadsheet.com'],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Sheet',
  url: SITE_URL,
  description: 'The ultimate Sugargoo Spreadsheet resource platform with curated product finds, shipping cost breakdowns, coupon codes, and expert reviews.',
  potentialAction: {
    '@type': 'SearchAction',
    target: SITE_URL + '/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <StructuredData data={orgSchema} />
      <StructuredData data={webSiteSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoriesSection />
        <IntroSection />
        <FeatureCards />
        <ArticlePreview />

        <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-accent-100/50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              Ready To Start Shopping?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
              Visit our main website to explore thousands of curated Sugargoo products, compare prices, and start building your perfect haul today.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Sugargoo Spreadsheet
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 font-semibold text-sm hover:border-accent-400 hover:text-accent-700 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}